import React from 'react';
import styles from './Details.module.scss';

// images
import dart from './../../../Assets/images/icons/dart.svg';
 
const Details = ({ title, text, setDetailsModalState, badge = 'Услуги компании' }) => {
  const closeModal = () => setDetailsModalState({
    title: '',
    text: '',
    active: false
  });

  return (
    <div className={styles.modal} onClick={closeModal}>
      <div className={styles.content} onClick={e => e.stopPropagation()}>
        <div className={styles.top}>
          <div className={styles.badge}>{badge}</div>
          <button className={styles.closeButton} type="button" onClick={closeModal} aria-label="Закрыть окно">
            <img src={dart} alt="" />
          </button>
        </div>
        <div className={styles.title}>{title}</div>
        <div className={styles.text} dangerouslySetInnerHTML={{ __html: text }}></div>
      </div>
    </div>
  )
}

export default React.memo(Details);
